import { request } from "utils/api";
import { RequestResponse } from "utils/base_api";

export interface LimitsData {
  plan: string;
  used_limits: {
    question_chat_messages: number;
    questions: number;
  };
  daily_limits: {
    trial: {
      questions: number;
      question_chat_messages: number;
    };
    free: {
      questions: number;
      question_chat_messages: number;
    };
    paid: {
      questions: number | null;
      question_chat_messages: number;
    };
  };
}

export function getLimits(): Promise<RequestResponse> {
  return request("/limits", { method: "GET" });
}
